import type { RouteRecordRaw } from 'vue-router';

import { $i } from '@silae/composables';
import { settingsLayoutComponents, settingsLayoutProps } from '~/pages/layout';
import { ROUTE_KEYS } from '~/router';

const CollaboratorsRoute: RouteRecordRaw = {
	path: 'collaborators',
	name: ROUTE_KEYS.SETTINGS_COLLABORATORS,
	meta: {
		label: 'collaborators.page-title',
		isSettingsNavEntry: true,
		icon: () => $i('users-gear'),
		auth: true
	},
	props: {
		...settingsLayoutProps
	},
	components: {
		default: () => import('./collaborators.page.vue'),
		...settingsLayoutComponents
	}
};

export default CollaboratorsRoute;
